import React, { useState } from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TrendingStoreScrole = () => {
    const imageList = [
        {
            title: 'Flipkart Summer Sale is Coming',
            description:
                '24 Hours Early Access For Plus Members - Get Huge Discounts Up To 90% OFF + Extra 10% OFF',
            logo: 'flipkart-logo.jpg',
        },
        {
            title: 'Great Summer Sale ',
            description:
                'Amazon Great Summer Sale  - Up To 80% OFF + 10% Discount (SBI Users) | Deals Revealed',
            logo: 'amazon-logo.jpg',
        },
        {
            title: 'Fashionation Sale is Live',
            description:
                'AJIO Fashionation Sale – Up To 80% OFF + Extra 10% OFF + 15% Ajio Supercash',
            logo: 'ajio-logo.jpg',
        },
        {
            title: 'Etihad Global Sale!',
            description:
                'Etihad Global Sale: Up To 26% OFF On Your Flight Bookings!',
            logo: 'etihad-airways-logo.jpg',
        },
        {
            title: 'Myntra Right to Fashion Sale',
            description:
                'Myntra Right to Fashion Sale: Flat 50% - 80% OFF + Extra Rs 500 OFF',
            logo: 'myntra-logo.jpg',
        },
        {
            title: 'EXCLUSIVE',
            description:
                "Watch 'Shark Tank India' Latest Episodes On SonyLIV & Get Flat 10% OFF On Your Subscription",
            logo: 'sonyliv-logo.jpg',
        },
    ];

    const [viewAll, setViewAll] = useState(true);


    const settings = {
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                },
            },
        ],
    };

    return (
        <Wrapper>
            <div className="heading">
                <h4 className='ms-sm-2 ms-0'>Premium Stores</h4>
                <p className="see-more" onClick={() => setViewAll(!viewAll)}>
                    {viewAll ? 'View All' : 'View Less'}
                </p>
            </div>

            {viewAll ? (
                <SliderWrapper className="slider">
                    <Slider {...settings}>
                        {imageList.map((item, idx) => (
                            <Card key={idx}>
                                <Header>
                                    <Title>{item.title}</Title>
                                    <Logo>
                                        <img src={`./images/${item.logo}`} alt={item.title} className='logo-img' />
                                    </Logo>
                                </Header>

                                <Description>{item.description}</Description>
                            </Card>
                        ))}
                    </Slider>
                </SliderWrapper>
            ) : (
                <ImageGrid>
                    {imageList.map((item, idx) => (
                        <Card1 key={idx}>
                            <Header>
                                <Title>{item.title}</Title>
                                <Logo>
                                    <img src={`./images/${item.logo}`} alt={item.title} className='logo-img' />
                                </Logo>
                            </Header>

                            <Description>{item.description}</Description>
                        </Card1>
                    ))}
                </ImageGrid>
            )}
        </Wrapper>
    );
};

export default TrendingStoreScrole;


const Wrapper = styled.section`
  background: #cccccc41;  
  padding: 20px;
//   max-width: 1200px;
  margin: auto;
  border-radius:5px;
  wigth:90%;
  margin-bottom:20px;

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .title {
    font-weight: bold;
    font-size: 20px;
  }

  .see-more {
    font-size: 16px;
    cursor: pointer;
    // text-decoration: underline;
    // color: #4a4a4bff;
  }
  .see-more:hover {
    text-decoration: underline;
    // color: #4a4a4bff;
  }
`;

const SliderWrapper = styled.div`
  .slick-slide {
    padding: 0 10px;
  }

  .slick-prev,
  .slick-next {
    width: 40px;
    height: 40px;
    z-index: 2;
  }
    .slick-track {
    display: flex;
  }

  .slick-slide {
    height: auto;
    display: flex;
  }

  .slick-slide > div {
    display: flex;
    height: 100%;
  }

  .slick-prev:before,
  .slick-next:before {
    color: #00000067;
    font-size: 24px;
  }

  @media(max-width:576px){
    .slick-slide {
      padding: 0 20px;
    }
  }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
  text-align: center;
  padding:1rem;

  .card-body {
    padding: 12px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
  }

  .card-text {
    font-size: 14px;
    color: #555;
    margin: 6px 0 12px;
  }

  .btn {
    display: inline-block;
    background: #007bff;
    color: #fff;
    padding: 6px 12px;
    font-size: 14px;
    text-decoration: none;
    border-radius: 4px;
  }

  .btn:hover {
    background: #0056b3;
  }
  @media(max-width:576px){
    img {
      height: auto;
    }
  }
  
`;

const Card1 = styled.div`
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 8px rgba(0,0,0,0.1);
  text-align: center;
  padding:1rem;
  height:auto;

  .card-body {
    padding: 12px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
  }

  .card-text {
    font-size: 14px;
    color: #555;
    margin: 6px 0 12px;
  }

  .btn {
    display: inline-block;
    background: #007bff;
    color: #fff;
    padding: 6px 12px;
    font-size: 14px;
    text-decoration: none;
    border-radius: 4px;
  }

  .btn:hover {
    background: #0056b3;
  }
  @media(max-width:576px){
    img {
      height: auto;
    }
  }
  
`;

const ImageGrid = styled.div`
  display: grid;
  // grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

   @media(max-width:992px){
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }
   @media(max-width:576px){
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    grid-template-columns: repeat(1, 1fr);
    height:auto;
    gap: 6px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

const Title = styled.div`
  background: #f1f3f6;
  padding: 6px 8px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 4px;
  color: #333;
  max-width: 43%;
  @media(max-width:992px){
    max-width: 75%;
  }

  @media(max-width:576px){
    max-width: 50%;
  }
`;

const Logo = styled.section`
    height: 75px;
    display: flex;
    align-items: center;     /* vertical center */
    justify-content: center; /* horizontal center */
    background: #fff;
  .logo-img {
    max-width: 100% !important;
    max-height: 100%;
    object-fit: contain;
  }
`;

const Description = styled.p`
  font-size: 13px;
  color: #555;
  line-height: 1.4;
  margin: 8px 0 12px;
`;
